import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import styled, { css } from 'styled-components';

import favicon from './favicon.png';

import Header from '../components/Header'
import Footer from '../components/Footer'
import './index.css'

const TemplateWrapper = ({ children, location }) => (
  <div>
    <Helmet
      title="Amy E. Zimmerman"
      // meta={[
      //   { name: 'description', content: 'Sample' },
      //   { name: 'keywords', content: 'sample, something' },
      // ]}
    >
      <link rel="shortcut icon" href={favicon} type="image/x-icon" />
      <link href="https://fonts.googleapis.com/css?family=Lato:300,400" rel="stylesheet" />
      <link href="https://fonts.googleapis.com/css?family=Open+Sans:300,400" rel="stylesheet" />
    </Helmet>
    <Header location={location}/>
    <div
      style={{
        margin: '0 auto',
        // maxWidth: 960,
        // padding: '0px 1.0875rem 1.45rem',
        paddingTop: 0,
      }}
    >
      {children()}
    <Footer location={location}/>
    </div>
  </div>
)

TemplateWrapper.propTypes = {
  children: PropTypes.func,
}

export default TemplateWrapper



// WEBPACK FOOTER //
// ./src/layouts/index.js